const axios = require("axios");

const send = async (value) => {
  console.log("Sending form...", value);
  console.log("SERVER_URL: ", process.env.REACT_APP_SERVER_URL);

  const { REACT_APP_SERVER_URL } = process.env;

  try {
    // @ts-ignore
    await axios.post(`${REACT_APP_SERVER_URL}/api/send`, value);
  } catch (error) {
    console.log({ error });
  }
};

export default send;
